import CoreIcon from '@components/std-components/CoreIcon'
import { ProductCardActionsIcon } from '@components/UI-Components/ProductCardActionsIcon'
import { ProductCardChip } from '@components/UI-Components/ProductCardChip'
import { ProductRecommended } from '@components/UI-Components/ProductCardOld'
import { ProductInfoItem } from '@components/UI-Components/ProductCardOld/ProductInfoItem'
import { ProductMedia } from '@components/UI-Components/ProductCardOld/ProductMedia'
import { ProductStatus } from '@components/UI-Components/ProductCardOld/ProductStatus'
import { ProductSlider } from '@components/UI-Components/ProductSlider'
import { SelectField } from '@components/UI-Components/SelectField'
import {
  AddIcon,
  CrossIcon,
  FilledStarIcon,
  StarIcon,
  CancelProductIcon
} from '@components/UI-Components/svg'
import PopupComponent from '@components/std-components/Popup'
import Chip from '@material-ui/core/Chip'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import InputLabel from '@material-ui/core/InputLabel'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import { ProductCardAttributeEnum } from '@modules/common/models/enums/ProductCardAttributeEnum'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'
import { ErrorContainer } from '@modules/errors/containers/Error'
import { useBuyingSessionGroup } from '@modules/wholesale/buyingGroupSummary/graphql/hooks'
import { useProductEnumList } from '@modules/wholesale/buyingSessionGroupProductWrapper/graphql/hooks'
import { ClientSearch } from '@modules/wholesale/clientSearch/container/ClientSearch'
import { useClients } from '@modules/wholesale/clientSettings/graphql/hooks'
import { ClusterExclusionMultiSelect } from '@modules/wholesale/clusterExclusionMultiSelect'
import { useClusters } from '@modules/wholesale/clusterSetting/graphql/hooks'
import { isBuyingSessionRestrictedForTag } from '@modules/wholesale/wsNavigations/constants/Tags'
import { useWholesaleZoneList } from '@modules/wholesale/wsNavigations/graphql/hooks'
import { CancelProductWrapper } from '@modules/wholesale/cancelOrderProduct/container'
import { defaultProductCardImage } from '@resources/images'
import { clientSearchManagementService } from '@services/wholesale/clientSearchManagementService'
import {
  getUpdateZoneList,
  hasWholeSaleChannel,
  isZAM,
  hasRetailChannel,
  isRetailCM,
  isWholesaleCM
} from '@services/commonServices'
import { getProductImagesForDetailsView } from '@services/productDetailService'
import { storage } from '@services/storageService'
import { hasUserRoles, PERMISSION_MAP } from '@services/userRoleService'
import { getWsProductRatings } from '@services/wholesale/getWholesaleProductRatingService'
import { wholeSaleProductService } from '@services/wholesale/productService'
import {
  isRetailChannel,
  isWholesaleChannel
} from '@services/wholesale/wholesaleBuyingSessionGroupsServices'
import { wholesalePriceService } from '@services/wholesale/wholesalePriceService'
import { stores, strings } from '@stores'
import { getPermissionsByEntityAndRoleForWholesale } from '@ws-routes/wholesaleRoutes'
import classNames from 'classnames'
import isEmpty from 'lodash/isEmpty'
import Rating from 'material-ui-rating'
import { useObserver } from 'mobx-react-lite'
import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import { AddChannelPopOver } from '../component/AddChannelPopOver'
import {
  useAddUpdateExcludedClustersForBSP,
  useBuyingSessionProductDetail,
  useBuyingSessionProductRating,
  useRatingTypes,
  useRemoveClientFromBuyingSessionProductExclusion,
  useUpdateBuyingSessionProductRating
} from '../graphql/hooks'
import { ProductCommentContainer } from './Comment'
import * as css from './ProductDetail.css'
import groupBy from 'lodash/groupBy'
import differenceBy from 'lodash/differenceBy'
import cn from 'classnames'
import { CancelProductContext } from '@modules/wholesale/cancelOrderProduct/context/cancelProduct-context'
import { CriteriaOperationType } from '@models'
import formatNumberByLocale from '@utils/format-number-by-locale'

const IFRAME_WIDTH = 400
const IFRAME_HEIGHT = 324
const LOOK_IMAGE_WIDTH = 167
const LOOK_IMAGE_HEIGHT = 250
const MAX_SELECTION_ALLOWED = 15
const COLUMN_WIDTH_FOR_SEARCH_CLIENT = 450

export const WSProductDetailContainer = () => {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const [openCancelProductPopup, setOpenCancelProductPopup] = React.useState(false)
    let {
      wsBuyingSessionProduct: { closeProductDetail, getImage, handleTagDelete },
      productDetail: {
        initStore,
        buyingSessionProductId,
        mutations,
        buyingSessionProductWhere,
        updateBuyingSessionProductRating,
        clearStore,
        setClientExclusion,
        isClientExclusion,
        setSelectedData,
        excludeClientsFromBuyingSessionProduct,
        addUpdateExcludedClustersForBSP,
        isClientExclusionInProcess,
        isClusterExclusionInProcess,
        filterExcludedClients,
        addChannelPopupAnchorEl,
        getChannelsToAdd,
        openAddChannelPopup,
        closeAddChannelPopup,
        isZoneExclusion,
        setZoneExclusion,
        handleProductStatusChange,
        addChannelAndSync,
        isCoreInProgress
      },
      clientSearch: { handlePopOverClick, anchorEl },
      clusterExclusionMultiSelect: {
        clusterListAnchorEl,
        handleClusterPopOverClick,
        rtlClusterListAnchorEl,
        handleRtlClusterPopOverClick
      },
      nav: {
        queryParams: { assortmentType, productId, buyingSessionGroupId, orderType }
      },
      buyingSessionProductPriceStore: { getPriceByBuyingSessionAndClient, fetchPriceData }
    } = stores
    const {
      uiStore: { fetchProductOrderDetails, reset }
    } = useContext(CancelProductContext)

    mutations.updateBuyingSessionProductRating = useUpdateBuyingSessionProductRating()
    mutations.removeClientFromBuyingSessionProductExclusion =
      useRemoveClientFromBuyingSessionProductExclusion() as any
    // Cluster Exclusion
    mutations.addUpdateExcludedClustersForBSP =
      useAddUpdateExcludedClustersForBSP() as any

    const currentUser: { id: string } = storage.getItem('user')
    const permissions = getPermissionsByEntityAndRoleForWholesale('buyingSessions')

    const [showCachesClient, setCacheClient] = React.useState(false)
    const [showCachesZone, setCacheZone] = React.useState(false)

    const [
      { data: buyingSessionGroupData },
      { loading, error, data },
      { data: productEnumList, loading: enumLoading, error: enumError },
      { data: ratingType },
      { data: productRatingData },
      { data: clientSearchData },
      { zones }
    ] = [
      useBuyingSessionGroup(buyingSessionGroupId),
      useBuyingSessionProductDetail(buyingSessionProductWhere),
      useProductEnumList(),
      useRatingTypes(),
      useBuyingSessionProductRating(currentUser.id, buyingSessionProductId),
      useClients({
        Doors: { EXIST_OPERATION: CriteriaOperationType.NN }
      }),
      useWholesaleZoneList()
    ]

    const product = data?.findVIPBuyingSessionProduct?.Items?.[0] ?? null

    const variableForFetchingPrices = useMemo(
      () => wholesalePriceService.getVariableForFetchingPrices(null, null),
      []
    )

    React.useEffect(() => {
      if (buyingSessionGroupId) {
        fetchPriceData(
          variableForFetchingPrices,
          buyingSessionGroupId,
          buyingSessionGroupId
        )
      }
    }, [buyingSessionGroupId, fetchPriceData, variableForFetchingPrices])

    React.useEffect(() => {
      initStore(buyingSessionGroupId, product?.Id)
      return () => {
        clearStore()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product?.Id])

    // Cluster Exclusion
    let excludedClusters = product?.clusterExclusion ?? []
    const excludedClustersByChannel = groupBy(excludedClusters, 'channel')
    const excludedWhlClusters = excludedClustersByChannel?.[VIPChannel.Wholesale] ?? []
    const excludedRtlClusters = excludedClustersByChannel?.[VIPChannel.Retail] ?? []

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { clusters: clustersDataForExclusion } = useClusters()

    const clustersByChannel = groupBy(clustersDataForExclusion, 'Channel')
    const wholesaleClusters = clustersByChannel?.[VIPChannel.Wholesale] ?? []
    const retailClusters = clustersByChannel?.[VIPChannel.Retail] ?? []

    if ((loading && isEmpty(data)) || (enumLoading && isEmpty(productEnumList))) {
      return <Skeleton />
    }
    if (error || enumError) return <ErrorContainer error={error} />
    const productEnums = productEnumList?.findEnumList?.Items ?? []
    const ratingTypes = ratingType?.findVIPRatingType?.Items ?? []
    const processedBuyingSessionProduct = product
      ? wholeSaleProductService.processProductsForGridView(
          [product],
          productEnums,
          getPriceByBuyingSessionAndClient(buyingSessionGroupId),
          '',
          t,
          null
        )
      : []

    const buyingSessionProduct: any = processedBuyingSessionProduct.length
      ? processedBuyingSessionProduct[0]
      : {}

    const productRatings = getWsProductRatings(
      productRatingData?.findVIPRating?.Items ?? [],
      ratingTypes
    )

    const {
      nodeInfo,
      externalImages,
      imageURL,
      attributes,
      status,
      averageRating,
      buyingSession,
      isActive,
      associatedLooks,
      isRecommendedProduct
    } = buyingSessionProduct

    const {
      images: productImages,
      iframeURL,
      videoURL
    } = getProductImagesForDetailsView(externalImages, imageURL)
    const channel = attributes.find(
      attribute => attribute.name === ProductCardAttributeEnum.channels
    )

    const isWhlBuyingSessionRestricted = isBuyingSessionRestrictedForTag(
      buyingSession,
      strings.channel,
      VIPChannel.Wholesale
    )
    const isRtlBuyingSessionRestricted = isBuyingSessionRestrictedForTag(
      buyingSession,
      strings.channel,
      VIPChannel.Retail
    )
    // Cluster Exclusion
    const { value: addedWholesaleClusters } = attributes.find(
      attribute => attribute.name === ProductCardAttributeEnum.wholesaleClusters
    )
    const { value: addedRetailClusters } = attributes.find(
      attribute => attribute.name === ProductCardAttributeEnum.retailClusters
    )

    const excludedClients = (product?.clientExclusion || []).filter(
      (client: any) => client.ClientType === VIPClientType.External && client.IsActive
    )
    const excludedZones = (product?.clientExclusion || []).filter(
      (client: any) => client.ClientType === VIPClientType.Internal && client.IsActive
    )
    const clientDataForExclusion = clientSearchData?.findVIPClient?.Items
      ? filterExcludedClients(
          clientSearchData?.findVIPClient?.Items.filter(
            client => client.ClientType === VIPClientType.External
          ),
          [],
          buyingSessionGroupData?.buyingSessionGroup?.ExcludedClients ?? []
        )
      : []
    const zoneDataForExclusion = clientSearchData?.findVIPClient?.Items
      ? filterExcludedClients(
          clientSearchData?.findVIPClient?.Items.filter(
            client => client.ClientType === VIPClientType.Internal
          ),
          [],
          buyingSessionGroupData?.buyingSessionGroup?.ExcludedClients ?? []
        )
      : []
    const isAllRTLClustersExcluded = !differenceBy(
      retailClusters,
      excludedRtlClusters,
      'Id'
    )?.length

    // Process response and filter result for selected zone
    let selectedRows = clientSearchManagementService.processClientData({
      clients: isZoneExclusion ? excludedZones : excludedClients
    } as any)

    const zoneList = getUpdateZoneList(zones || [])
    const isZAMUserLoggedIn = isZAM()
    const hasWholeSaleAsChannel = hasWholeSaleChannel(channel?.value)
    const hasRetailAsChannel = hasRetailChannel(channel?.value)

    const isClientExclusionDisable = !!(
      assortmentType ||
      isWhlBuyingSessionRestricted ||
      isZAMUserLoggedIn ||
      orderType
    )

    // This check is needed so that empty popover should not display
    const canOpenClientExclusionPopOver = !(
      isClientExclusionDisable && !excludedClients.length
    )

    const isZoneExclusionDisable = !!(
      assortmentType ||
      isRtlBuyingSessionRestricted ||
      isZAMUserLoggedIn ||
      orderType
    )

    const canOpenZoneExclusionPopOver = !(isZoneExclusionDisable && !excludedZones.length)

    // Cluster Exclusion
    const excludedClustersLen = excludedWhlClusters?.length
    const excludedRtlClustersLen = excludedRtlClusters?.length
    const canOpenClusterExclusionPopOver =
      hasWholeSaleAsChannel && isActive && !isZAMUserLoggedIn && !assortmentType

    const canOpenRTLClusterExclusionPopOver =
      hasRetailAsChannel && isActive && !isZAMUserLoggedIn && !assortmentType

    const showDisabledExcludedClustersPopOver =
      (!!assortmentType || isZAMUserLoggedIn) && !!excludedClustersLen

    const showDisabledExcludedRtlClustersPopOver =
      (!!assortmentType || isZAMUserLoggedIn) && !!excludedRtlClustersLen

    const canOpenWhlClusterExclusionPopOver =
      canOpenClusterExclusionPopOver && !isWhlBuyingSessionRestricted
    const canOpenRtlClusterExclusionPopOver =
      canOpenRTLClusterExclusionPopOver && !isRtlBuyingSessionRestricted

    const openWhlClusterExclusionList =
      canOpenWhlClusterExclusionPopOver || showDisabledExcludedClustersPopOver
        ? handleClusterPopOverClick
        : null

    const openRtlClusterExclusionList =
      canOpenRtlClusterExclusionPopOver || showDisabledExcludedRtlClustersPopOver
        ? handleRtlClusterPopOverClick
        : null

    const bsgChannels = buyingSessionGroupData?.buyingSessionGroup?.channels
    const isWholesale = isWholesaleChannel(bsgChannels)
    const isRetail = isRetailChannel(bsgChannels)
    // Can be edited  1. retail only then check for isRtlBuyingSessionRestricted & not whl cm
    // 2. wholesale only then check for isWhlBuyingSessionRestricted & not rtl cm
    // 3. both then check for isWhlBuyingSessionRestricted && isRtlBuyingSessionRestricted
    let canEditBasedOnChannel = true
    if (isWholesale && isRetail) {
      canEditBasedOnChannel =
        !isWhlBuyingSessionRestricted && !isRtlBuyingSessionRestricted
    } else if (isWholesale) {
      canEditBasedOnChannel = !isWhlBuyingSessionRestricted && !isRetailCM()
    } else if (isRetail) {
      canEditBasedOnChannel = !isRtlBuyingSessionRestricted && !isWholesaleCM()
    }
    const canEdit =
      canEditBasedOnChannel && buyingSessionProduct.isActive && !isZAMUserLoggedIn
    const canEditProductStatus =
      !isCoreInProgress &&
      !isRtlBuyingSessionRestricted &&
      buyingSessionProduct?.isActive &&
      isRetail &&
      hasUserRoles(
        PERMISSION_MAP.find(item => item?.id === VIPChannel.Retail)?.allowedRoles
      )

    const hasRetailRoles = hasUserRoles(
      PERMISSION_MAP.find(ele => ele.id === VIPChannel.Retail)?.allowedRoles
    )

    const hasWholesaleRoles = hasUserRoles(
      PERMISSION_MAP.find(ele => ele.id === VIPChannel.Wholesale)?.allowedRoles
    )
    const handleCancelOrReplaceClick = () => {
      fetchProductOrderDetails(buyingSessionGroupId, buyingSessionProductId)
      setOpenCancelProductPopup(true)
    }

    const handleDialogClose = () => {
      setOpenCancelProductPopup(false)
      reset()
    }

    const handleOnClickZone = (event: any) => {
      if (!canOpenZoneExclusionPopOver) return
      setClientExclusion(false)
      setZoneExclusion(true)
      handlePopOverClick(event)
    }

    const handleOnClickWHL = (event: any) => {
      if (!canOpenClientExclusionPopOver) return
      setZoneExclusion(false)
      setClientExclusion(true)
      handlePopOverClick(event)
    }

    return (
      <div>
        <Drawer
          anchor='right'
          open={!!buyingSessionProductId && !openCancelProductPopup}
          onClose={closeProductDetail}
        >
          <div className={css.drawer}>
            <div className={css.header}>
              <Typography className={css.text}>{nodeInfo?.title ?? 'NA'}</Typography>
              <div className={css.action}>
                {isActive && (
                  <div
                    className={css.cancelBtnWrapper}
                    onClick={handleCancelOrReplaceClick}
                  >
                    <img src={CancelProductIcon} alt='' />
                    <Typography className={cn(css.text, css.cancelBtnText)}>
                      {t('bb.productDetails.cancelOrReplace', 'Cancel/Replace')}
                    </Typography>
                  </div>
                )}
                <div style={{ width: 58 }}>
                  <ProductCardActionsIcon
                    label={averageRating}
                    iconName={
                      <img
                        src={averageRating ? FilledStarIcon : StarIcon}
                        className={canEdit ? css.cursor : css.disabled}
                        alt=''
                      />
                    }
                    status={Boolean(averageRating)}
                  />
                </div>
                <img
                  src={CrossIcon}
                  className={css.cursor}
                  onClick={closeProductDetail}
                  alt=''
                />
              </div>
            </div>
            <Divider />

            <div className={css.productDetail}>
              <div>
                <div className={css.status}>
                  {status && (
                    <ProductStatus
                      status={status}
                      statusTagStyle={
                        productImages && productImages.length > 1 ? css.statusTag : null
                      }
                    />
                  )}
                  {isRecommendedProduct ? <ProductRecommended /> : null}
                  {buyingSessionProduct?.isCore ? (
                    <CoreIcon
                      isInactiveFlagPresent={!buyingSessionProduct?.isActive}
                      isOpenedInASlider={true}
                    />
                  ) : null}
                </div>
                <ProductSlider
                  productMedia={{
                    productImages,
                    IFrameURL: iframeURL ?? '',
                    videoURL: videoURL ?? '',
                    IFRAME_HEIGHT,
                    IFRAME_WIDTH
                  }}
                />
                <div className={css.lookContainer}>
                  {associatedLooks.length ? (
                    <div className={css.lookImageContainer}>
                      <Typography className={css.text}>
                        {t(
                          'bb.bsg.productAttributes.associatedLooks',
                          'Associated Looks'
                        )}
                      </Typography>
                      {associatedLooks.map(look => (
                        <div key={look?.Id}>
                          <div className={css.lookImage}>
                            <ProductMedia
                              image={
                                getImage(look?.Images ?? null) || defaultProductCardImage
                              }
                              height={LOOK_IMAGE_HEIGHT}
                              width={LOOK_IMAGE_WIDTH}
                              imgWidth={LOOK_IMAGE_WIDTH}
                            />
                          </div>
                          <div className={css.lookNameMargin}>
                            <Typography className={css.text}>
                              {look?.Name ?? ''}
                            </Typography>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className={css.productInfo}>
                <div className={css.productInfoItem}>
                  <Typography className={css.text}>
                    {nodeInfo?.subtitle ?? 'NA'}
                  </Typography>
                </div>
                <div className={css.productChipItem}>
                  {/* Channel Component */}
                  {channel?.value?.length > 0 && (
                    <div className={css.channelChip}>
                      <ProductCardChip
                        content={channel.value}
                        onDelete={
                          assortmentType || productId || orderType
                            ? null
                            : chip =>
                                handleTagDelete(
                                  buyingSessionProduct,
                                  chip.id,
                                  channel.name,
                                  t
                                )
                        }
                        node={buyingSessionProduct}
                      />
                    </div>
                  )}
                  {permissions.canEdit &&
                  !assortmentType &&
                  !orderType &&
                  bsgChannels?.length > channel?.value?.length &&
                  getChannelsToAdd(bsgChannels, channel?.value)?.length ? (
                    <div className={classNames(css.productInfoItem, css.channelChip)}>
                      <Tooltip title={t('bb.common.label.addChannel', 'Add Channel')}>
                        <img
                          src={AddIcon}
                          className={css.cursor}
                          onClick={openAddChannelPopup}
                          alt=''
                        />
                      </Tooltip>
                    </div>
                  ) : null}
                  {addChannelPopupAnchorEl ? (
                    <AddChannelPopOver
                      onClose={closeAddChannelPopup}
                      anchorEl={addChannelPopupAnchorEl}
                      onAddClick={channel => addChannelAndSync(channel)}
                      isDisabled={false}
                      channels={getChannelsToAdd(bsgChannels, channel?.value)}
                    />
                  ) : null}
                  <div>
                    <div style={{ display: 'flex' }}>
                      {/* client exclusion component */}
                      {isWholesale && (
                        <div
                          className={classNames(
                            css.exclusion,
                            !hasWholesaleRoles ? css.disabledExclusion : null
                          )}
                        >
                          <Typography className={css.text}>
                            {t('bb.common.label.clientExclusions', 'Client Exclusions')}
                          </Typography>
                          <Chip
                            className={css.chip}
                            label={formatNumberByLocale(excludedClients.length)}
                            onClick={handleOnClickWHL}
                          />
                        </div>
                      )}
                      {/***  cluster WHL exclusion component ***/}
                      {isWholesale && (
                        <div
                          className={classNames(
                            css.exclusion,
                            !hasWholesaleRoles ? css.disabledExclusion : null
                          )}
                        >
                          <Typography className={css.text}>
                            {t(
                              'bb.common.label.whlClusterExclusions',
                              'Wholesale Cluster Exclusions'
                            )}
                          </Typography>
                          <Chip
                            className={css.chip}
                            label={formatNumberByLocale(excludedClustersLen)}
                            onClick={openWhlClusterExclusionList}
                          />
                        </div>
                      )}
                    </div>
                    {/* zone exclusion component */}
                    {isRetail && (
                      <div style={{ display: 'flex' }}>
                        <div
                          className={classNames(
                            css.exclusion,
                            !hasRetailRoles ||
                              buyingSessionProduct?.isCore ||
                              isCoreInProgress
                              ? css.disabledExclusion
                              : null
                          )}
                        >
                          <Typography className={css.text}>
                            {t('bb.common.label.zoneExclusion', 'Zone Exclusion')}
                          </Typography>
                          <Chip
                            className={css.chip}
                            label={formatNumberByLocale(excludedZones.length)}
                            onClick={handleOnClickZone}
                          />
                        </div>
                        {/*** rtl cluster exclusion component ***/}
                        <div
                          className={classNames(
                            css.exclusion,
                            !hasRetailRoles ? css.disabledExclusion : null
                          )}
                        >
                          <Typography className={css.text}>
                            {t(
                              'bb.common.label.rtlClusterExclusion',
                              'Retail Cluster Exclusions'
                            )}
                          </Typography>
                          <Chip
                            className={css.chip}
                            label={formatNumberByLocale(excludedRtlClustersLen)}
                            onClick={openRtlClusterExclusionList}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {anchorEl && (
                  <ClientSearch
                    clientData={
                      isClientExclusion
                        ? clientDataForExclusion
                        : isZoneExclusion
                        ? zoneDataForExclusion
                        : []
                    }
                    zones={isClientExclusion ? zoneList : []}
                    allowMultiSelect={true}
                    showAllFilter={true}
                    setSelectedData={setSelectedData}
                    maxSelectionLimit={MAX_SELECTION_ALLOWED}
                    isActionAllowed={true}
                    isActionInProcess={isClientExclusionInProcess}
                    isActionDisabled={false}
                    handleSubmit={async () => {
                      await excludeClientsFromBuyingSessionProduct(selectedRows)
                      if (!showCachesZone && isZoneExclusion) setCacheZone(true)
                      else if (!showCachesClient && !isZoneExclusion) setCacheClient(true)
                    }}
                    columnWidth={COLUMN_WIDTH_FOR_SEARCH_CLIENT}
                    canSelectAll={true}
                    selectedRows={selectedRows}
                  />
                )}

                {/* MultiSelect WHL Cluster List for exclusion */}
                {clusterListAnchorEl && (
                  <ClusterExclusionMultiSelect
                    clusterData={wholesaleClusters || []}
                    excludedClusters={excludedClusters}
                    isActionInProcess={isClusterExclusionInProcess}
                    handleApply={addUpdateExcludedClustersForBSP}
                    showDisabledExcludedClustersPopOver={
                      showDisabledExcludedClustersPopOver
                    }
                    addedClusters={addedWholesaleClusters}
                    getAssortmentExcludedClusters={() => excludedWhlClusters}
                  />
                )}
                {/* MultiSelect RTL Cluster List for exclusion */}
                {rtlClusterListAnchorEl && (
                  <ClusterExclusionMultiSelect
                    clusterData={retailClusters || []}
                    excludedClusters={excludedClusters}
                    isActionInProcess={isClusterExclusionInProcess}
                    handleApply={addUpdateExcludedClustersForBSP}
                    showDisabledExcludedClustersPopOver={
                      showDisabledExcludedRtlClustersPopOver
                    }
                    addedClusters={addedRetailClusters}
                    getAssortmentExcludedClusters={() => excludedRtlClusters}
                  />
                )}
                {isRetail ? (
                  <>
                    {excludedZones.length ? (
                      <Typography className={css.exclusionWarning}>
                        {t(
                          'bb.productDetails.excludedZonesWarning',
                          'Product cannot be marked as core as it is excluded from one or more zones'
                        )}
                      </Typography>
                    ) : null}
                    {isAllRTLClustersExcluded ? (
                      <Typography className={css.exclusionWarning}>
                        {t(
                          'bb.productDetails.excludedClusterWarning',
                          'Product cannot be marked as core as it is excluded from all the clusters'
                        )}
                      </Typography>
                    ) : null}
                    {buyingSessionProduct?.isCore ? (
                      <Typography className={css.exclusionWarning}>
                        {t(
                          'bb.productDetails.coreProductWarning',
                          'Product cannot be excluded from zone as it is marked as core'
                        )}
                      </Typography>
                    ) : null}
                    <InputLabel htmlFor='productStatus'>
                      {t('bb.productDetails.productStatus', 'Product Status')}
                    </InputLabel>
                    <SelectField
                      className={css.statuses}
                      input={
                        <OutlinedInput
                          notched={false}
                          labelWidth={105}
                          id='productStatus'
                        />
                      }
                      id={'productStatus'}
                      value={buyingSessionProduct?.isCore}
                      options={[
                        {
                          id: true,
                          name: t('bb.filterFieldGroup.productStatus.with', 'Core')
                        },
                        {
                          id: false,
                          name: t('bb.filterFieldGroup.productStatus.without', 'Non Core')
                        }
                      ]}
                      disabled={
                        !canEditProductStatus ||
                        excludedZones.length ||
                        isAllRTLClustersExcluded ||
                        !buyingSessionProduct?.node?.channels?.includes(VIPChannel.Retail)
                      }
                      onChange={handleProductStatusChange}
                    />
                    {!buyingSessionProduct?.node?.channels?.includes(
                      VIPChannel.Retail
                    ) ? (
                      <Typography className={css.exclusionWarning}>
                        {t(
                          'bb.productDetails.excludedRetailChannelWarning',
                          'This product cannot be mark as core as it does not have retail channel'
                        )}
                      </Typography>
                    ) : null}
                  </>
                ) : null}
                <div className={css.productInfoItem}>
                  <Typography className={css.text}>{nodeInfo?.legend ?? 'NA'}</Typography>
                </div>
                <div className={css.productInfoItem}>
                  <Typography className={css.text}>
                    {t('bb.productDetails.rating', 'RATING')}
                  </Typography>
                  <div>
                    {productRatings.map(({ Id, TypeName, Value }) => (
                      <div className={css.productInfoItemContent} key={Id}>
                        <Typography
                          className={css.productInfoItemText}
                          style={{ flex: 1 }}
                        >
                          {TypeName}
                        </Typography>
                        <Rating
                          id={Id}
                          value={Value}
                          disableHover={true}
                          max={5}
                          onChange={
                            canEdit
                              ? value =>
                                  updateBuyingSessionProductRating({
                                    buyingSessionProduct: buyingSessionProduct.productId,
                                    ratingType: Id,
                                    ratingValue: value,
                                    previousValue: Value
                                  })
                              : null
                          }
                          iconNormal={<img src={StarIcon} alt='' />}
                          iconFilled={<img src={FilledStarIcon} alt='' />}
                          iconHovered={<img src={FilledStarIcon} alt='' />}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div className={css.productInfoItem}>
                  <Typography className={css.text}>
                    {t('bb.productDetails.details', 'DETAILS')}
                  </Typography>
                  <div className={css.attributeContainer}>
                    {attributes.map((attribute, index) => {
                      if (!attribute.isChip && !attribute.isPriceAttribute) {
                        return (
                          <div className={css.attribute} key={index}>
                            <ProductInfoItem
                              productInfoContainerStyle={css.attributeInfo}
                              key={index}
                              title={t(
                                `bb.bsg.productAttributes.${attribute.name}`,
                                attribute.label
                              )}
                              contentTextStyle={css.contentText}
                              content={attribute.value || 'NA'}
                              titleTextStyle={css.titleText}
                            />
                          </div>
                        )
                      }
                      return null
                    })}
                  </div>
                </div>
                <div>
                  <ProductCommentContainer
                    canEdit={canEdit}
                    currentUser={currentUser}
                    showUserAddComment={!isZAMUserLoggedIn}
                  />
                </div>
              </div>
            </div>
          </div>
        </Drawer>
        <PopupComponent
          open={openCancelProductPopup}
          onClose={handleDialogClose}
          contentStyle={{
            width: '90%',
            height: '90%',
            padding: 0
          }}
          className={'popup-container'}
          position='center center'
          arrow={false}
          closeOnDocumentClick={false}
          lockScroll
        >
          <CancelProductWrapper
            product={buyingSessionProduct}
            bsgChannels={bsgChannels}
            closePopup={handleDialogClose}
          />
        </PopupComponent>
      </div>
    )
  })
}
